export const schoolStats = [
  {
    id: 1,
    label: "Total Students",
    value: "1,245",
    icon: "Users",
    trend: "+12%",
    color: "text-blue-500",
    bgColor: "bg-blue-50",
  },
  {
    id: 2,
    label: "Career Paths",
    value: "982",
    icon: "Briefcase",
    trend: "+8%",
    color: "text-purple-500",
    bgColor: "bg-purple-50",
  },
  {
    id: 3,
    label: "Task Completion",
    value: "87%",
    icon: "CheckCircle",
    trend: "+5%",
    color: "text-green-500",
    bgColor: "bg-green-50",
  },
]

export const careerPathDistribution = [
  { name: "STEM", value: 35, color: "#3B82F6" },
  { name: "Arts", value: 25, color: "#EC4899" },
  { name: "Commerce", value: 15, color: "#F59E0B" },
  { name: "Business", value: 10, color: "#10B981" },
  { name: "Other", value: 15, color: "#8B5CF6" },
]

export const classPerformance = [
  {
    id: 1,
    className: "JSS 1",
    teacher: "Mr. Alade",
    totalTasks: "42 / 50",
  },
  {
    id: 2,
    className: "JSS 2",
    teacher: "Mrs. David",
    totalTasks: "38 / 50",
  },
  {
    id: 3,
    className: "JSS 3",
    teacher: "Mr. Rotimi",
    totalTasks: "32 / 50",
  },
]
